import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/noticeAll',
    name: 'noticeAll',
    component: () => import('../views/NoticeAllView.vue'),
    meta: {
      requireAuth: false,  // 添加该字段，表示进入这个路由是需要登录的
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/SearchView.vue'),
    meta: {
      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactUsView.vue'),
    meta: {
      requireAuth: false,  // 添加该字段，表示进入这个路由是需要登录的
    }
  },
  {
    path: '/selectscipt',
    name: 'selectscipt',
    component: () => import('../views/SelectScriptView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/MessageManageView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/NoticeView.vue')
  },
  {
    path: '/termsofservice',
    name: 'termsofservice',
    component: () => import('../views/TermsofserviceView.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/UserView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
  },
  {
    path: '/mydatabase',
    component: () => import('../views/MyDatabaseView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    children: [
      {
        path: '/',
        name: 'main',
        component: () => import('../views/MyData/MyDatabaseMainView.vue'),
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      },
      {
        path: 'data',
        name: 'main',
        component: () => import('../views/MyData/MyDatabaseDataView.vue'),
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      }
    ]
  },
  {
    path: '/fluorescence',
    component: () => import('../views/FluorescenceManagView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    children: [
      {
        path: '/',
        name: 'myData',
        component: () => import('../views/FluorescenceManag/FluorescenceManageMyDataView.vue'),
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      },
      {
        path: 'public',
        name: 'public',
        component: () => import('../views/FluorescenceManag/FluorescenceManagPublicView.vue'),
        meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
      },
    ]
  },
  {
    path: '/similarity',
    component: () => import('../views/SimilarityView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    children: [
      {
        path: '/',
        name: 'myData',
        component: () => import('../views/Similarity/SimilarityMyDataView.vue'),
        meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
      },
      {
        path: 'public',
        name: 'public',
        component: () => import('../views/Similarity/SimilarityPublicView.vue'),
        meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
      },
    ]
  },
  {
    path: '/spectraltraceability',
    component: () => import('../views/SpectralTraceabilityView.vue'),
    meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    children: [
      {
        path: '/',
        name: 'myData',
        component: () => import('../views/SpectralTraceability/SpectralTraceabilityMyDataView.vue'),
        meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
      },
      {
        path: 'public',
        name: 'public',
        component: () => import('../views/SpectralTraceability/SpectralTraceabilityPublicView.vue'),
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
